import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet, Scroll } from '@angular/router';
import { registerLocaleData, ViewportScroller } from '@angular/common';
import localeFi  from '@angular/common/locales/fi';
import { ClientInitializerService, DebugService, SettingsService, StorageService } from 'core-lib';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'core-lib';
import { NgZone } from '@angular/core';
import { PageLoaderComponent, ConsentBannerComponent } from 'core-lib';
import { DemoSettingsSelectorComponent } from "./components/demo-settings-selector/demo-settings-selector.component";
import { filter } from 'rxjs';
import { ScrollService } from 'core-lib';
import { PrimeNG } from 'primeng/config';



@Component({
    selector: 'app-root',
    imports: [RouterOutlet, PageLoaderComponent, ConsentBannerComponent, DemoSettingsSelectorComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})



export class AppComponent {
  title:string = 'hlx-sampo';
  clientId:string;
  loading: boolean = false;
  isDemo:boolean = false;
  showHeroImg:boolean = true;

  constructor(
    private elementRef: ElementRef,
    private translate: TranslateService,
    private clientInitializer: ClientInitializerService,
    private languageService: LanguageService,
    private zone: NgZone,
    private scrollService: ScrollService,
    private primeconfig: PrimeNG,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
    private debug: DebugService,
    private settings: SettingsService,
  ) {
    this.clientId = this.elementRef.nativeElement.getAttribute('clientId');
    
    
    //exposing component to the outside here
    //componentFn called from outside and it in return calls callExampleFunction()
    
    //same as window['angularComponentReference'], but typescript would throw an error
    (window as { [key: string]: any })['angularComponentReference'] = {
      zone: this.zone,  
      componentFn: (value:any) => this.changeLangOutsideApp(value),
      component: this,
    };
   

    clientInitializer.setClientId(this.clientId);

    // add translations to prime components
    this.translate.get('primeng').subscribe(res => this.primeconfig.setTranslation(res));

    registerLocaleData(localeFi);
  
    this.checkIfDemoApp();     

    this.scrollService.setupScrollRestorationListener();
    
  }

  ngOnInit() {
    // ckeck queryparams, if debugmode activated
    this.activatedRoute.queryParamMap.subscribe((res:any) => {
      
      let params =  res.params;
      if (params['debug']) {
        this.debug.setDebugMode(parseInt(params['debug']));
        this.router.navigate(
          [], 
          {queryParams: { debug: null }, queryParamsHandling: 'merge' }
        );
      }
    })

    if (window.location.pathname == '/preview') {
      this.showHeroImg = false;
    }
    
  }

  changeLangOutsideApp(lang:any):any {
    this.languageService.changeLang(lang);
  }

  checkIfDemoApp() {
    this.isDemo = this.settings.isDemoApp();
  }
  
}
